<template>
  <el-dialog
    class="paySuccessDialog"
    title="交易成功"
    :visible.sync="visible"
    width="500px"
    :before-close="dialogBeforeClose"
  >
    <div class="content">
      <img src="@/assets/images/pay_success.png" />
      <div class="title">操作成功</div>
      <div class="info">恭喜您！订单支付成功</div>
    </div>
    <div class="footer" slot="footer">
      <el-button type="primary" @click="visible = false">关 闭</el-button>
      <el-button v-if="showInfoBtn" @click="goPage">查看购买详情</el-button>
    </div>
  </el-dialog>
</template>
<script>
export default {
  data() {
    return {
      visible: false,
    };
  },
  computed: {
    showInfoBtn: function () {
      return this.$route.path.indexOf("/staging/") != 0;
    },
  },
  methods: {
    open() {
      this.visible = true;
    },
    dialogBeforeClose() {
      this.visible = false;
    },
    goPage() {
      this.visible = false;
      window.open(window.location.origin + "/#/staging/myApp");
    },
  },
};
</script>
<style lang="scss" scoped>
.paySuccessDialog {
  .content {
    height: 200px;
    text-align: center;
    img {
      width: 60px;
    }
    .title {
      margin-top: 10px;
      height: 30px;
      line-height: 30px;
      font-size: 18px;
      color: #000;
    }
    .info {
      margin-top: 20px;
      height: 20px;
      line-height: 20px;
      font-size: 14px;
      color: #333;
    }
  }
  ::v-deep {
    .el-dialog__footer {
      .footer {
        display: flex;
        flex-direction: row;
        justify-content: space-evenly;
        align-items: center;
        padding-bottom: 10px;
      }
    }
  }
}
</style>
